import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Observable } from 'rxjs';
import type { NoticeSeverity, SystemNotice } from '../_services/system-status.service';

/**
 * Floating stack for transient (autoDismissMs) notices — fixed top-center, overlays the content
 * (and open dialogs) instead of pushing the page down like the persistent info bar does.
 * Never declared in any template: SystemStatusService creates it on <body> on the first toast
 * and assigns `toasts$`/`dismiss` itself. Tapping a toast dismisses it early.
 */
@Component({
    selector: 'app-system-toasts',
    templateUrl: './system-toasts.component.html',
    styleUrls: ['./system-toasts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('toast', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-10px)' }),
                animate('220ms ease', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                animate('180ms ease', style({ opacity: 0, transform: 'translateY(-8px)' })),
            ]),
        ]),
    ],
    standalone: false
})
export class SystemToastsComponent {
  @HostBinding('attr.role') readonly role = 'status';
  @HostBinding('attr.aria-live') readonly ariaLive = 'polite';

  /** both assigned by SystemStatusService right after createComponent() */
  toasts$!: Observable<SystemNotice[]>;
  dismiss: (key: string) => void = () => {};

  trackByKey(_index: number, notice: SystemNotice): string {
    return notice.key;
  }

  iconFor(severity: NoticeSeverity): string {
    return severity === 'warn' ? 'warning' : severity === 'info' ? 'info' : severity === 'success' ? 'check_circle' : 'priority_high';
  }
}
